module.exports = __webpack_public_path__ + "img/tv_phone_mockup.fdcdf7d1.png";